import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { menuToggler } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';
import Nav from '../Navigation/Nav';

const styles = css`
  display: block;
  position: relative;
  z-index: 5;
  .ToggleNav_buttonShowDesktop {
    display: flex;
    background: transparent;
    border: 0;
    height: 60px;
    width: 80px;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    @media (min-width: 992px) {
      padding: 0 0 0 0;
      margin: 0 0 0 0;
      height: 70px;
    }
  }
  .ToggleNav_button {
    display: block;
    background: transparent;
    border: 0;
    padding: 20px 15px;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .ToggleNav_buttonIcon {
    width: 35px;
    height: 16px;
    position: relative;
    margin: 0 auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  .ToggleNav_buttonIcon span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${colors.brand2};
    border-radius: 0;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }
  .ToggleNav_buttonIcon span:nth-child(1) {
    top: 0px;
  }
  .ToggleNav_buttonIcon span:nth-child(2),.ToggleNav_buttonIcon span:nth-child(3) {
    top: 7px;
  }
  .ToggleNav_buttonIcon span:nth-child(4) {
    top: 14px;
  }
  .ToggleNav_buttonIcon.open span:nth-child(1) {
    top: 7px;
    width: 0%;
    left: 50%;
  }
  .ToggleNav_buttonIcon.open span:nth-child(2) {
    transform: rotate(45deg);
  }
  .ToggleNav_buttonIcon.open span:nth-child(3) {
    transform: rotate(-45deg);
  }
  .ToggleNav_buttonIcon.open span:nth-child(4) {
    top: 7px;
    width: 0%;
    left: 50%;
  }
  .ToggleNav_wrapper {
    position: fixed;
    top: 61px;
    right: 0;
    bottom: 0;
    width: calc(100vw - 30px);
    overflow-y: scroll;
    z-index: 100;
    background-color: ${colors.white};
    transform: translateX(100vw);
    transition: transform 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
    @media (min-width: 992px) {
      top: 0;
      padding: 80px 20px;
    }
    &-active {
      transform: translateX(0);
    }
  }
  .ToggleNav_menuClose {
    display: none;
    @media (min-width: 992px) {
      display: block;
      position: absolute;
      right: 15px;
      top: 15px;
      width: 20px;
      height: 20px;
      padding: 0;
      box-sizing: content-box;
      background-image: url('/images/icon-close.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 20px 20px;
      background-color: transparent;
      border: 0;
      cursor: pointer;
    }
  }
  .ToggleNav_menu {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    @media (min-width: 992px) {
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
    }
  }
  .ToggleNav_menuItem {
    list-style: none;
    border-bottom: 1px solid ${colors.neutral};
    width: 100%;
    @media (min-width: 992px) {
      display: inline-block;
      margin: 0;
      vertical-align: top;
      border: 0;
      position: relative;
      width: auto;
    }
  }
  .ToggleNav_menuHeading {
    font-family: ${typography.Condensed};
    font-size: 18px;
    font-weight: 700;
    padding: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.brand1};
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand3};
      position: relative;
      margin: 0 0 0 5px;
    }
    &:focus {
      background-color: ${colors.neutral};
      &::after {
        content: '';
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 6px solid ${colors.brand3};
        border-top: 0;
        position: relative;
        margin: 0 0 0 5px;
      }
    }
    &-link {
      &::after {
        display: none;
      }
    }
    @media (min-width: 992px) {
      cursor: default !important;
      position: relative;
      transition: all .3s ease;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 1px;
      &::after {
        display: none;
      }
      &:hover {
        background-color: transparent;
        outline: none;
        border: none;
      }
      &:focus {
        background-color: transparent;
        border: none;
      }
    }
  }
  .ToggleNav_menuLink {
    font-family: ${typography.Condensed};
    font-size: 18px;
    font-weight: 700;
    padding: 15px 0;
    cursor: pointer;
    display: block;
    color: ${colors.brand1Dark};
    @media (min-width: 992px) {
      font-weight: 400;
      font-size: 14px;
      cursor: default;
      position: relative;
      padding: 0 15px;
      line-height: 100px;
      height: 100px;
      transition: all .3s ease;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 1px;
      &:hover, &:focus {
        outline: none;
        border: none;
      }
    }
  }
  .ToggleNav_subMenu {
    display: none;
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    @media (min-width: 992px) {
      display: block;
      position: relative;
      width: auto;
      padding: 0 20px 0 0;
    }
  }
  .ToggleNav_menuItem:last-child .ToggleNav_subMenu {
    @media (min-width: 992px) {
      left: auto;
      right: 0;
    }
  }
  .ToggleNav_subMenu-active {
    display: block;
  }
  .ToggleNav_subMenuItem a {
    color: ${colors.brand1};
    padding: 8px 15px;
    display: block;
    transition: all .3s ease;
    background-color: ${colors.white};
    font-weight: 400;
    &:hover {
      color: ${colors.brand2}
    }
  }
  .ToggleNav_subSubMenu {
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    .ToggleNav_subSubMenuHeading {
      font-weight: 700 !important;
      padding: 8px 15px;
      display: block;
    }
    .ToggleNav_subMenuItem a {
      font-weight: 400;
    }
  }
`;

class ToggleNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuActive: false,
    };
  }
  toggleMenu = event => {
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    this.setState({
      menuActive: !this.state.menuActive,
    });
  }
  render() {
    const { menuActive } = this.state;
    const { widget } = this.props;
    return (
      <div className={styles} >
        <button className={get(widget, 'header_options[0].show_hamburger_on_desktop') ? 'ToggleNav_buttonShowDesktop' : 'ToggleNav_button'} onClick={this.toggleMenu}>
          <div className={`ToggleNav_buttonIcon ${menuActive ? 'open' : ''}`}>
            <span />
            <span />
            <span />
            <span />
          </div>
        </button>
        <div className={`ToggleNav_wrapper ${menuActive ? 'ToggleNav_wrapper-active' : ''}`}>
          <button className="ToggleNav_menuClose" onClick={this.toggleMenu} />
          <Nav
            id="toggle"
            className="ToggleNav_menu"
            toggleSubMenus
            menuProps={{
              className: 'ToggleNav_menuItem',
              subMenuClassName: 'ToggleNav_subMenu',
              subMenuActiveClassName: 'ToggleNav_subMenu-active',
              headingClassName: 'ToggleNav_menuHeading',
              itemClassName: 'ToggleNav_subMenuItem',
            }}
          />
        </div>
      </div>
    );
  }
}

ToggleNav.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default menuToggler(ToggleNav);



// WEBPACK FOOTER //
// ./src/components/Header3/ToggleNav.js